import React, { lazy, Suspense } from 'react';

import { Redirect, Route, Switch, useLocation } from 'react-router-dom';

import { ContentRoute, LayoutSplashScreen, useHtmlClassService } from '../_metronic/layout';

import { BuilderPage } from './pages/BuilderPage';
import { DashboardPage } from './pages/DashboardPage';
import { GradingPage } from './pages/grading';
import { HomePage } from './pages/home';
import { OnDemandPaymentsCancelPage } from './pages/on-demand-payments/cancel';
import { OnDemandPaymentsPage } from './pages/on-demand-payments/root';
import { OnDemandPaymentsSuccessPage } from './pages/on-demand-payments/success';
import { CancelSubmissionPage, DraftSubmissionPage, SubmissionsPage, SuccessSubmissionPage } from './pages/submissions';
import { CANCEL_SUBMISSION_ROUTE, DRAFT_SUBMISSION_ROUTE, SUBMISSIONS_ROUTE, SUCCESS_SUBMISSION_ROUTE } from './pages/submissions/routes';

const GoogleMaterialPage = lazy(() =>
  import('./modules/GoogleMaterialExamples/GoogleMaterialPage'),
);
const ReactBootstrapPage = lazy(() =>
  import('./modules/ReactBootstrapExamples/ReactBootstrapPage'),
);
const ECommercePage = lazy(() =>
  import('./modules/ECommerce/pages/eCommercePage'),
);
const UserProfilePage = lazy(() =>
  import('./modules/UserProfile/UserProfilePage'),
);

export default function BasePage() {
  const uiService = useHtmlClassService();
  const { pathname } = useLocation();

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Redirect from="/:url*(/+)" to={pathname.slice(0, -1)} />
        <Redirect exact from="/" to="/home" />

        <ContentRoute path="/home" component={HomePage} />
        <ContentRoute path="/home/" component={HomePage} />
        <ContentRoute path="/grading" component={GradingPage} />

        <ContentRoute path="/on-demand-payments/cancel" component={OnDemandPaymentsCancelPage} />
        <ContentRoute path="/on-demand-payments/success" component={OnDemandPaymentsSuccessPage} />
        <ContentRoute path="/on-demand-payments" component={OnDemandPaymentsPage} />

        <ContentRoute path={CANCEL_SUBMISSION_ROUTE} component={CancelSubmissionPage} />
        <ContentRoute path={DRAFT_SUBMISSION_ROUTE} component={DraftSubmissionPage} />
        <ContentRoute path={SUCCESS_SUBMISSION_ROUTE} component={SuccessSubmissionPage} />
        <ContentRoute path={SUBMISSIONS_ROUTE} component={SubmissionsPage} />

        <Route path="/user-profile" component={UserProfilePage} />

        {uiService.config.dci.showMetronicStuff === true
          && (
            <>
              <ContentRoute path="/builder" component={BuilderPage} />
              <ContentRoute path="/dashboard" component={DashboardPage} />

              <Route path="/google-material" component={GoogleMaterialPage} />
              <Route path="/react-bootstrap" component={ReactBootstrapPage} />
              <Route path="/e-commerce" component={ECommercePage} />
            </>
          )}

        <Redirect to="error/error-v1" />
      </Switch>
    </Suspense>
  );
}
